import React from 'react';
import CardAsset from './CardAsset';

function Assets ({ filteredAssets, origin, assets, stages, configFile }) {
  return (
    <div>
      {
        <div>
          {
            filteredAssets &&
            filteredAssets.length > 0 &&
            filteredAssets.map(
              (asset, i) =>
                stages.id === asset.currentStage && (
                  // filtro para solo pintar los assets en los stage que correspondan
                  <div key={i}>
                    <CardAsset asset={asset} origin={origin} configFile={configFile} />
                  </div>
                )
            )
          }
        </div>
      }
    </div>
  );
}

export default Assets;
